async function GetProduct (StrElementID, optionreturn, ProdId)  {
  //console.log("connected!");
 // console.log(StrElementID);
  const relatedProductsContainer = document.getElementById(StrElementID);
  const productTag = relatedProductsContainer.dataset.productId;
  var collection = ''
   

  // console.log(productTag);
  if (!productTag) {
    console.error("Product ID not found");
    return;
  }

  const apiUrl = "https://columbiard.myshopify.com/api/2024-01/graphql.json";
  const headers = {
    "Content-Type": "application/graphql",
    "X-Shopify-Storefront-Access-Token": "0424bf3d37ce68fe31a21e8b85c063f1",
  };

  const fetchApi = async (query) => {
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: query,
      });

      if (response.ok) return response.json();
      throw new Error(await response.text());
    } catch (error) {
      console.error(error);
    }
  };

  const getProductsByTag = (tag) =>
    fetchApi(`
        {
          products(first: 200, query: "tag:'${tag}'") {
            edges {
              node {
                id
                handle
                title
                publishedAt
                featuredImage {
                  url
                }
                totalInventory
                variants(first: 250) {
                  edges {
                    node {
                      id
                      image {
                        url(transform: {maxHeight: 200, maxWidth: 200})
                      }
                      selectedOptions {
                        value
                        name
                      }
                    }
                  }
                }
                priceRange {
                  minVariantPrice {
                    amount
                  }
                }
                compareAtPriceRange {
                  maxVariantPrice {
                    amount
                  }
                }
              }
            }
          }
        }
    `);

  // get products with product id as tag
  const response = await getProductsByTag(productTag);
  console.log("🚀 ~ productTag:", productTag);
  console.log("🚀 ~ response:", response);
  console.log("🚀 ~ PRoductID:", ProdId);

  if (!response.data) {
    console.error("⚠ No related products found");
    return;
  }

  const products = response.data.products.edges.map((edge) => edge.node);
  //console.log("🚀 ~ produdt:", products);
  //  console.log("🚀 ~ produdt:", ProdId);



        var contect = relatedProductsContainer.innerHTML 
        contect = contect.replace('<script async=""> GetProduct("'+StrElementID+'","div",'+ProdId+'); </script>',' ')
      //   console.log("🚀 ~ produdt:",'<script async=""> GetProduct("'+StrElementID+'","div",'+ProdId+'); </script>');  
        contect = contect.replace('<script async=""> GetProduct("'+StrElementID+'","imagen",'+ProdId+'); </script>',' ')
      //   console.log("🚀 ~ produdt:",'<script async=""> GetProduct("'+StrElementID+'","imagen",'+ProdId+'); </script>');
      
      const hrefMatch = contect.match(/href="([^"]*)"/);
      if (hrefMatch) {
        const hrefValue = hrefMatch[1];
      
        // Encontrar el índice donde comienza "products"
        const productsIndex = hrefValue.indexOf("/products");
      
        // Si encuentra "products", extraer desde el inicio hasta esa posición
        if (productsIndex !== -1) {
           collection = hrefValue.substring(0, productsIndex);
   //       console.log(collection); // Imprimir la parte de la cadena hasta "products"
        } else {
          collection = '';
  //        console.log("No se encontró 'products' en el href.");
        }
      }
  
// Función que evalúa si el producto fue publicado hace menos de 30 días
function esProductoNuevo(publishedAt) {
  const publishedDate = new Date(publishedAt);
  const now = new Date();
  const millisecondsIn30Days = 60 * 24 * 60 * 60 * 1000;

  return (now - publishedDate) < millisecondsIn30Days;
}
  

  // populate products inside related-products element
  const relatedProductsHtml = products.map((product) => {
      const productHande = product.handle
      const proudctTitle = product.title
      var ProductidR = product.id;
                    ProductidR = ProductidR.replace('gid://shopify/Product/','');
      var TotalInventory = product.totalInventory;
      var Price = parseFloat(product.priceRange.minVariantPrice.amount);
      var compare_at_price = parseFloat(product.compareAtPriceRange.maxVariantPrice.amount);      
      const publishedAt = product.publishedAt;
      const EsNuevo = esProductoNuevo(publishedAt);    
      var claseTipo = EsNuevo ? ' is-new' : '';
      if (compare_at_price > Price) {
            var claseTipo = ' is-sale'
      }
      
    
      let badgeHTML = '';
      if (EsNuevo) {
        badgeHTML += `<span class="badge badge--newitem">N</span>`;
      }
    
    if (ProdId!=ProductidR)
    {
        
          const variants = product.variants.edges.map((edge) => edge.node);
                 var values = "";
              const relatedProductsHtmlVariant = variants.map((variant) => {
                  var lsreturn = null;
                var Imagen = ''
                    var id = variant.id;
                    id = id.replace('gid://shopify/ProductVariant/','')
                    if (variant.image) {
                         Imagen = variant.image.url;
                      }
                    const ColorName = variant.selectedOptions[0].value;
                    var ColorNameLow =ColorName.replace(/\s+/g, '-').toLowerCase();
                    const ColorNameA = ColorName.split(' ');
                    const color_swatch_fallback = ColorNameA[ColorNameA.length - 1].toLowerCase();
                        
      
                    if (!values.includes(ColorName)) {
                         values = values + ',' + ColorName;
                       if (TotalInventory >= 1) {
                        if (optionreturn == 'imagen') {  
                                           lsreturn = `
                    <a 
                            href="${collection}/products/${productHande}?variant=${id}" 
                            class="color-swatch--with-image color-swatch color-swatch--small color-swatch--${ColorNameLow}${claseTipo}" 
                                data-variant-id="${id}" 
                                data-variant-image="${Imagen}" 
                                
                                aria-label="${proudctTitle} - ${ColorName}" 
                                style="background-color: ${color_swatch_fallback}; background-image: url(${Imagen});">
                                <span class="visually-hidden">${ColorName}</span>
                            </a>
                    
                    
                                   
                                              `;
                        
                                          }
                          if (optionreturn == 'div') {       
                                lsreturn =  `
                                   	   <div
                                           class="grid-product__color-image grid-product__color-image--${id} small--hide">
                                       </div>                	          
                                          `;
                        
                          }
                       }
                              
                    }
                  return lsreturn;
                });
   
        return  relatedProductsHtmlVariant.join('');
     }
  });


  
//if (optionreturn == 'imagen') {contect = ''}
relatedProductsContainer.innerHTML = contect + relatedProductsHtml.join('');


      const colorSwatchImage= '.grid-product__color-image';
      const colorSwatch= '.color-swatch--with-image';
     //     console.log(colorSwatch);
  if (optionreturn == 'imagen') {  
    //console.log(relatedProductsContainer.querySelectorAll(colorSwatch));
        relatedProductsContainer.querySelectorAll(colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', function() {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = document.querySelector('.grid-product__color-image--' + id);
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', function() {
            var id = swatch.dataset.variantId;
            document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
          });
        });
    }
  

}

